"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, inputVariants, QuantityInput, Separator, TextBody, Tooltip, UnstyledButton } from "@opensea/ui-kit";
import { Add, Remove } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { getOfferPricePrecision } from "../../../../../lib/zod/schema";
import { MINIMUM_LISTING_PRICE, OFFER_MAX_DECIMALS } from "../../../constants";
export const IncrementAllPricesInput = () => {
  const $ = _c(39);
  const t = useTranslations("wallet.IncrementAllPricesInput");
  const [expanded, setExpanded] = useState(false);
  const {
    control,
    setValue
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "listings"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const listings = useWatch(t0);
  const firstListingFloorPrice = listings.length > 0 ? listings[0].floorPrice : null;
  const t1 = firstListingFloorPrice || OFFER_MAX_DECIMALS;
  let t2;
  let t3;
  if ($[2] !== t1) {
    const decimalPrecision = getOfferPricePrecision(t1);
    t2 = Number;
    t3 = (10 ** -decimalPrecision).toFixed(decimalPrecision);
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const defaultIncrementValue = t2(t3);
  const [incrementValue, setIncrementValue] = useState(defaultIncrementValue);
  let t4;
  if ($[5] !== incrementValue || $[6] !== listings || $[7] !== setValue) {
    t4 = () => {
      if (!incrementValue) {
        return;
      }
      listings.forEach((listing, index) => {
        setValue(`listings.${index}.price`, Math.max(bn(listing.price || 0).minus(incrementValue).toNumber(), MINIMUM_LISTING_PRICE), {
          shouldDirty: true
        });
      });
    };
    $[5] = incrementValue;
    $[6] = listings;
    $[7] = setValue;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleDecrement = t4;
  let t5;
  if ($[9] !== incrementValue || $[10] !== listings || $[11] !== setValue) {
    t5 = () => {
      if (!incrementValue) {
        return;
      }
      listings.forEach((listing_0, index_0) => {
        setValue(`listings.${index_0}.price`, bn(listing_0.price || 0).plus(incrementValue).toNumber(), {
          shouldDirty: true
        });
      });
    };
    $[9] = incrementValue;
    $[10] = listings;
    $[11] = setValue;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleIncrement = t5;
  if (!expanded) {
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = classNames(inputVariants(), "h-8 w-fit gap-3 px-3 py-1.5");
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== t) {
      t7 = t("decrementAllPrices");
      $[14] = t;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t7) {
      t8 = <TextBody size="xs">{t7}</TextBody>;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <UnstyledButton onClick={() => setExpanded(true)}><Remove size={20} /></UnstyledButton>;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== t8) {
      t10 = <Tooltip content={t8}>{t9}</Tooltip>;
      $[19] = t8;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    let t11;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Separator className="h-5" orientation="vertical" />;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== t) {
      t12 = t("incrementAllPrices");
      $[22] = t;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    let t13;
    if ($[24] !== t12) {
      t13 = <TextBody size="xs">{t12}</TextBody>;
      $[24] = t12;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    let t14;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <UnstyledButton onClick={() => setExpanded(true)}><Add size={20} /></UnstyledButton>;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    let t15;
    if ($[27] !== t13) {
      t15 = <Tooltip content={t13}>{t14}</Tooltip>;
      $[27] = t13;
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    let t16;
    if ($[29] !== t10 || $[30] !== t15 || $[31] !== t6) {
      t16 = <FlexCenter className={t6}>{t10}{t11}{t15}</FlexCenter>;
      $[29] = t10;
      $[30] = t15;
      $[31] = t6;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    return t16;
  }
  let t6;
  if ($[33] !== handleDecrement || $[34] !== handleIncrement) {
    t6 = (value, source) => {
      if (source === "input") {
        setIncrementValue(value);
      } else {
        if (source === "increment") {
          handleIncrement();
        } else {
          handleDecrement();
        }
      }
    };
    $[33] = handleDecrement;
    $[34] = handleIncrement;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  let t7;
  if ($[36] !== incrementValue || $[37] !== t6) {
    t7 = <QuantityInput onValueChange={t6} placeholder="0.0" size="sm" value={incrementValue} />;
    $[36] = incrementValue;
    $[37] = t6;
    $[38] = t7;
  } else {
    t7 = $[38];
  }
  return t7;
};